import { FormControl, Grid, Typography, useTheme } from '@mui/material';
import React from 'react'
import { IRootState } from '../../store/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { Operators, PickemParlayType } from '../pick6/store/types';
import { GetLayout, GetOperatorLabel, GetOperatorLink, GetPickemParlayTypeLabel, GetValidPickemParlayTypesForOperator, Layout } from './store/types';
import SelectComponent from './Select';
import { useHistory } from 'react-router-dom';
import { setPickemParlayType, setTimeFrame } from './store/slice';
import TimeFrameDropdown from './TimeFrameDropdown';
import StateSelectComponent from './StateSelect'

const Toolbar = () => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    parlayFilters,
    operator,
    timeframe,
  } = useSelector((state: IRootState) => state.pickemOptimizer);

  const handleOperator = (newOperator: Operators) => {
    history.push(`/fantasy-optimizers/${GetOperatorLink(newOperator)}`);
    history.go(0);
  };

  const handlePickemParlayType = (newType: PickemParlayType) => {
    dispatch(setPickemParlayType(newType))
  };

  const getLabel = (type: PickemParlayType): string => {
    return GetPickemParlayTypeLabel(type, operators[parlayFilters.operator?.toString().toUpperCase() || ''] ?? Operators.NONE);
  };

  const operators: { [key: string]: Operators } = {
    'PRIZEPICKS': Operators.PRIZEPICKS,
    'UNDERDOG': Operators.UNDERDOG,
    'PICK6': Operators.PICK6,
  }

  const layout = GetLayout()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container spacing={2} className="filter-label-wrapper-content">
          {layout !== Layout.MobileApp && (
            <Grid item xs={12}>
              <Grid
                sx={{
                  marginBottom: '16px',
                  marginTop: '16px',
                  [theme.breakpoints.down('xs')]: {
                    marginBottom: '0px',
                  },
                }}
                container
                spacing={2}
                id="back-to-top-anchor"
              >
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}
                  item
                  xs={9}
                  sm={operator === Operators.NONE ? 9 : 12}
                >
                  <Typography variant="h2" color='primary' sx={{
                    fontSize: { xs: '24px !important', md: '36px !important' },
                    fontWeight: 900,
                    lineHeight: 1,
                    marginRight: '8px',
                  }}>
                    {operator !== Operators.NONE ? GetOperatorLabel(operators[parlayFilters.operator?.toString().toUpperCase() || '']) : GetOperatorLabel(operator)} {operator !== Operators.NONE ? 'Entry' : 'Parlay'} Builder
                  </Typography>
                </Grid>
                {operator === Operators.NONE && (
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                      justifyContent: 'center',
                    }}
                    item
                    xs={3}
                    sm={3}
                    className="filter-wrapper state"
                  >
                    <FormControl sx={{
                      minWidth: 100,
                      width: '100%',
                      '& .MuiOutlinedInput-input': {
                        padding: '16px 12px',
                      },
                      '& .MuiInputBase-input': {
                        fontWeight: 600,
                      },
                    }}>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} className="filter-wrapper filters" mb={0}>
            <Grid container spacing={1}>
              {operator !== Operators.NONE && (
                <>
                  <Grid
                    item
                    xs={5}
                  >
                    <SelectComponent
                      backgroundColorOverride={'#1C1C1C'}
                      options={Object.values(Operators)
                        .filter((o: Operators) => o !== Operators.NONE && o !== Operators.PICK6)}
                      label={parlayFilters.operator}
                      getMenuItemLabel={(item) => GetOperatorLabel(item)}
                      getValue={(item) => item}
                      handleClick={handleOperator}
                    />
                  </Grid>
                  {GetValidPickemParlayTypesForOperator(operators[parlayFilters.operator?.toString().toUpperCase() || '']).length > 1 && (
                    <Grid item xs={6}>
                      <SelectComponent
                        backgroundColorOverride={'#1C1C1C'}
                        options={GetValidPickemParlayTypesForOperator(
                          operators[parlayFilters.operator?.toString().toUpperCase() || '']
                        )}
                        label={getLabel(parlayFilters.pickemParlayType ?? PickemParlayType.FLEX)}
                        getMenuItemLabel={getLabel}
                        getValue={(item) => item}
                        handleClick={handlePickemParlayType}
                      />
                    </Grid>
                  )}
                </>
              )}
              <Grid item xs={5} pl={1}>
                <TimeFrameDropdown timeframe={timeframe} SetTimeFrame={(newTimeFrame: string) => dispatch(setTimeFrame(newTimeFrame))} />
              </Grid>
              <Grid item xs={1} pr={1} >
                <StateSelectComponent toolbarStyle={true} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Toolbar